module.exports = __webpack_public_path__ + "static/media/oberflex-frenefr112-1200x2490.6a92a214.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-frenefr112-1200x2490.jpg
// module id = 1022
// module chunks = 37